import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Activity } from 'lucide-react';
export function ResetMethod() {
  return <section className="py-24 px-4 bg-dark-900 relative overflow-hidden" data-id="element-144">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gold/5 rounded-full blur-[100px] pointer-events-none translate-x-1/2 -translate-y-1/2" data-id="element-145" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-146">
        <FadeIn data-id="element-147">
          <div className="text-center mb-12" data-id="element-148">
            <span className="text-gold tracking-widest uppercase text-sm font-semibold mb-4 block" data-id="element-149">
              El Mecanismo Único
            </span>
            <h2 className="text-4xl md:text-5xl mb-8" data-id="element-150">El Método R.E.S.E.T.</h2>
            <p className="text-xl text-offwhite/60 font-serif italic" data-id="element-151">
              (Regulación Emocional y Somática de Emergencia tras el Trauma)
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-152">
          <div className="bg-gradient-to-b from-dark-800 to-dark-900 p-8 md:p-12 rounded-2xl border border-gold/20 shadow-[0_0_30px_rgba(212,175,55,0.05)]" data-id="element-153">
            <div className="flex justify-center mb-8" data-id="element-154">
              <div className="p-4 bg-dark-900 rounded-full border border-gold/30" data-id="element-155">
                <Activity className="w-8 h-8 text-gold" data-id="element-156" />
              </div>
            </div>

            <div className="space-y-6 text-lg md:text-xl text-offwhite/80 font-light leading-relaxed text-center" data-id="element-157">
              <p data-id="element-158">
                La mayoría de los libros te explican cómo es un narcisista.{' '}
                <strong className="text-gold font-normal" data-id="element-159">
                  Este sistema te explica cómo sanar TÚ.
                </strong>
              </p>
              <p data-id="element-160">
                No usamos solo lógica; usamos neurociencia aplicada. A través de
                la Teoría Polivagal, enseñamos a tu nervio vago a salir del
                estado de "congelamiento" y "alerta máxima".
              </p>
              <p className="text-offwhite font-medium" data-id="element-161">
                Cuando sanas el cuerpo, la adicción química al narcisista se
                rompe automáticamente. No es fuerza de voluntad; es biología
                aplicada.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}